import { render, staticRenderFns } from "./AppListComponent.vue?vue&type=template&id=2c01cefb&scoped=true"
import script from "./AppListComponent.vue?vue&type=script&lang=js"
export * from "./AppListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c01cefb",
  null
  
)

export default component.exports